export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13354.80f40286.jpg";